export default __webpack_public_path__ + "static/media/card1-1920x1080Tiny.00df17e7.png";